import { useEffect } from 'react';

import { type InvoiceType } from '@goshippo/libraries/shared/InvoicesTable';

import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import { type AxiosError, type AxiosResponse } from 'axios';

import { type HttpClientError } from '~/utils/APIError';
import { newRelic } from '~/utils/newRelic/newRelic';

import { INVOICE_DETAILS_CACHE_KEY } from '../constants/invoicePage.const';
import * as invoicesService from '../services/invoices.service';

export const useFetchInvoiceDetails = (
  invoiceId: string,
): UseQueryResult<AxiosResponse<InvoiceType, AxiosError>, HttpClientError> => {
  const query = useQuery<AxiosResponse<InvoiceType, AxiosError>, HttpClientError>({
    queryFn: () => invoicesService.getById(invoiceId),
    queryKey: [invoiceId, INVOICE_DETAILS_CACHE_KEY],
  });

  useEffect(() => {
    if (query.error)
      newRelic.noticeError('Error while fetching invoice details', { error: query.error });
  }, [query.error]);

  return query;
};
